var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"text-danger"},_vm._l((_vm.messages),function(m){return _c('div',{key:m},[_vm._v(_vm._s(m))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }